// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1ktEF","name":"ConsentHeader_name__2-IIK","birthday":"ConsentHeader_birthday__13WkX","skeleton":"ConsentHeader_skeleton__2SanV"};